export interface DataEntity_Detail_07_Interface {
    id: number,
    main_id: number,
  
    reference: string,
    indication: string,
    correction: string,
    error: string,
    repeatability: string,
    eccentricity: string,
    
    uncertainty: string,
    converage: string,
  }
  
  export function Empty_DataEntity_Detail_07_Interface(): DataEntity_Detail_07_Interface {
    return {
      id: 0,
      main_id: 0,
  
      reference: '',
      indication:'' ,
      correction: '',
      error: '',
      repeatability: '',
      eccentricity: '',
      
      uncertainty: '',
      converage:'' ,
    }
  }